export default __webpack_public_path__ + "static/media/EL_TIEMPO_LATINO.0aebd8bb.png";